var _toConsumableArray = require("D:\\writingAssitant\\writing-assistant\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _slicedToArray = require("D:\\writingAssitant\\writing-assistant\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("D:\\writingAssitant\\writing-assistant\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");

!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("react"));else if ("function" == typeof define && define.amd) define(["react"], t);else {
    var r = "object" == typeof exports ? t(require("react")) : t(e[void 0]);

    for (var n in r) {
      ("object" == typeof exports ? exports : e)[n] = r[n];
    }
  }
}(window, function (e) {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 12);
  }([function (e, t, r) {
    "use strict";

    var n = r(3),
        o = Object.prototype.toString;

    function i(e) {
      return "[object Array]" === o.call(e);
    }

    function s(e) {
      return void 0 === e;
    }

    function u(e) {
      return null !== e && "object" == typeof e;
    }

    function a(e) {
      return "[object Function]" === o.call(e);
    }

    function c(e, t) {
      if (null != e) if ("object" != typeof e && (e = [e]), i(e)) for (var r = 0, n = e.length; r < n; r++) {
        t.call(null, e[r], r, e);
      } else for (var o in e) {
        Object.prototype.hasOwnProperty.call(e, o) && t.call(null, e[o], o, e);
      }
    }

    e.exports = {
      isArray: i,
      isArrayBuffer: function isArrayBuffer(e) {
        return "[object ArrayBuffer]" === o.call(e);
      },
      isBuffer: function isBuffer(e) {
        return null !== e && !s(e) && null !== e.constructor && !s(e.constructor) && "function" == typeof e.constructor.isBuffer && e.constructor.isBuffer(e);
      },
      isFormData: function isFormData(e) {
        return "undefined" != typeof FormData && e instanceof FormData;
      },
      isArrayBufferView: function isArrayBufferView(e) {
        return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && e.buffer instanceof ArrayBuffer;
      },
      isString: function isString(e) {
        return "string" == typeof e;
      },
      isNumber: function isNumber(e) {
        return "number" == typeof e;
      },
      isObject: u,
      isUndefined: s,
      isDate: function isDate(e) {
        return "[object Date]" === o.call(e);
      },
      isFile: function isFile(e) {
        return "[object File]" === o.call(e);
      },
      isBlob: function isBlob(e) {
        return "[object Blob]" === o.call(e);
      },
      isFunction: a,
      isStream: function isStream(e) {
        return u(e) && a(e.pipe);
      },
      isURLSearchParams: function isURLSearchParams(e) {
        return "undefined" != typeof URLSearchParams && e instanceof URLSearchParams;
      },
      isStandardBrowserEnv: function isStandardBrowserEnv() {
        return ("undefined" == typeof navigator || "ReactNative" !== navigator.product && "NativeScript" !== navigator.product && "NS" !== navigator.product) && "undefined" != typeof window && "undefined" != typeof document;
      },
      forEach: c,
      merge: function e() {
        var t = {};

        function r(r, n) {
          "object" == typeof t[n] && "object" == typeof r ? t[n] = e(t[n], r) : t[n] = r;
        }

        for (var n = 0, o = arguments.length; n < o; n++) {
          c(arguments[n], r);
        }

        return t;
      },
      deepMerge: function e() {
        var t = {};

        function r(r, n) {
          "object" == typeof t[n] && "object" == typeof r ? t[n] = e(t[n], r) : t[n] = "object" == typeof r ? e({}, r) : r;
        }

        for (var n = 0, o = arguments.length; n < o; n++) {
          c(arguments[n], r);
        }

        return t;
      },
      extend: function extend(e, t, r) {
        return c(t, function (t, o) {
          e[o] = r && "function" == typeof t ? n(t, r) : t;
        }), e;
      },
      trim: function trim(e) {
        return e.replace(/^\s*/, "").replace(/\s*$/, "");
      }
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    t.URLGroup = function (e) {
      return function (t) {
        for (var _len = arguments.length, r = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          r[_key - 1] = arguments[_key];
        }

        return "".concat(e).concat(function (e, t) {
          var r = "",
              n = e.length;

          for (var o = 0; o < n; o++) {
            r += e[o], o !== n - 1 && (r += t[o]);
          }

          return r;
        }(t, r));
      };
    }, t.AxiosController = {
      cancelerCallbackQueue: []
    };
  }, function (e, t, r) {
    "use strict";

    var n = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = n(r(13)),
        i = n(r(31)),
        s = r(35),
        u = r(1),
        a = o.default.CancelToken;
    o.default.defaults.paramsSerializer = function (e) {
      return i.default.stringify(e, {
        arrayFormat: "bracket"
      });
    }, o.default.defaults.baseURL = "/api", t.initAxiosInstance = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        renderErrorMessage: function renderErrorMessage() {}
      };
      var t = o.default.create(e),
          r = {
        errorHandler: function errorHandler(t) {
          if (!(t instanceof Error) && t && "string" == typeof t.message) return;
          var r = s.get(t, "response.status", 0),
              n = s.get(t, "response.data.code", r),
              o = e.errorMessageMap || {},
              i = e.defaultErrorMessage || "服务器错误";
          if (0 === n) throw t;
          {
            var _r = o[n] || s.get(t, "response.data.msg", i);

            e.renderErrorMessage(_r);
          }
        }
      },
          n = Object.assign(Object.assign({}, r), e);
      return t.interceptors.request.use(function (e) {
        var t = a.source();
        var r = Object.assign({
          cancelToken: t.token
        }, e);
        var n = u.AxiosController.cancelerCallbackQueue.shift();
        return n && n(t.cancel), r;
      }), t.interceptors.response.use(function (e) {
        return e;
      }, n.errorHandler), t;
    }, t.default = o.default;
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t) {
      return function () {
        for (var r = new Array(arguments.length), n = 0; n < r.length; n++) {
          r[n] = arguments[n];
        }

        return e.apply(t, r);
      };
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(0);

    function o(e) {
      return encodeURIComponent(e).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }

    e.exports = function (e, t, r) {
      if (!t) return e;
      var i;
      if (r) i = r(t);else if (n.isURLSearchParams(t)) i = t.toString();else {
        var s = [];
        n.forEach(t, function (e, t) {
          null != e && (n.isArray(e) ? t += "[]" : e = [e], n.forEach(e, function (e) {
            n.isDate(e) ? e = e.toISOString() : n.isObject(e) && (e = JSON.stringify(e)), s.push(o(t) + "=" + o(e));
          }));
        }), i = s.join("&");
      }

      if (i) {
        var u = e.indexOf("#");
        -1 !== u && (e = e.slice(0, u)), e += (-1 === e.indexOf("?") ? "?" : "&") + i;
      }

      return e;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e) {
      return !(!e || !e.__CANCEL__);
    };
  }, function (e, t, r) {
    "use strict";

    (function (t) {
      var n = r(0),
          o = r(20),
          i = {
        "Content-Type": "application/x-www-form-urlencoded"
      };

      function s(e, t) {
        !n.isUndefined(e) && n.isUndefined(e["Content-Type"]) && (e["Content-Type"] = t);
      }

      var u,
          a = {
        adapter: ("undefined" != typeof XMLHttpRequest ? u = r(7) : void 0 !== t && "[object process]" === Object.prototype.toString.call(t) && (u = r(7)), u),
        transformRequest: [function (e, t) {
          return o(t, "Accept"), o(t, "Content-Type"), n.isFormData(e) || n.isArrayBuffer(e) || n.isBuffer(e) || n.isStream(e) || n.isFile(e) || n.isBlob(e) ? e : n.isArrayBufferView(e) ? e.buffer : n.isURLSearchParams(e) ? (s(t, "application/x-www-form-urlencoded;charset=utf-8"), e.toString()) : n.isObject(e) ? (s(t, "application/json;charset=utf-8"), JSON.stringify(e)) : e;
        }],
        transformResponse: [function (e) {
          if ("string" == typeof e) try {
            e = JSON.parse(e);
          } catch (e) {}
          return e;
        }],
        timeout: 0,
        xsrfCookieName: "XSRF-TOKEN",
        xsrfHeaderName: "X-XSRF-TOKEN",
        maxContentLength: -1,
        validateStatus: function validateStatus(e) {
          return e >= 200 && e < 300;
        }
      };
      a.headers = {
        common: {
          Accept: "application/json, text/plain, */*"
        }
      }, n.forEach(["delete", "get", "head"], function (e) {
        a.headers[e] = {};
      }), n.forEach(["post", "put", "patch"], function (e) {
        a.headers[e] = n.merge(i);
      }), e.exports = a;
    }).call(this, r(19));
  }, function (e, t, r) {
    "use strict";

    var n = r(0),
        o = r(21),
        i = r(4),
        s = r(23),
        u = r(26),
        a = r(27),
        c = r(8);

    e.exports = function (e) {
      return new Promise(function (t, f) {
        var l = e.data,
            p = e.headers;
        n.isFormData(l) && delete p["Content-Type"];
        var d = new XMLHttpRequest();

        if (e.auth) {
          var h = e.auth.username || "",
              m = e.auth.password || "";
          p.Authorization = "Basic " + btoa(h + ":" + m);
        }

        var y = s(e.baseURL, e.url);

        if (d.open(e.method.toUpperCase(), i(y, e.params, e.paramsSerializer), !0), d.timeout = e.timeout, d.onreadystatechange = function () {
          if (d && 4 === d.readyState && (0 !== d.status || d.responseURL && 0 === d.responseURL.indexOf("file:"))) {
            var r = "getAllResponseHeaders" in d ? u(d.getAllResponseHeaders()) : null,
                n = {
              data: e.responseType && "text" !== e.responseType ? d.response : d.responseText,
              status: d.status,
              statusText: d.statusText,
              headers: r,
              config: e,
              request: d
            };
            o(t, f, n), d = null;
          }
        }, d.onabort = function () {
          d && (f(c("Request aborted", e, "ECONNABORTED", d)), d = null);
        }, d.onerror = function () {
          f(c("Network Error", e, null, d)), d = null;
        }, d.ontimeout = function () {
          var t = "timeout of " + e.timeout + "ms exceeded";
          e.timeoutErrorMessage && (t = e.timeoutErrorMessage), f(c(t, e, "ECONNABORTED", d)), d = null;
        }, n.isStandardBrowserEnv()) {
          var g = r(28),
              v = (e.withCredentials || a(y)) && e.xsrfCookieName ? g.read(e.xsrfCookieName) : void 0;
          v && (p[e.xsrfHeaderName] = v);
        }

        if ("setRequestHeader" in d && n.forEach(p, function (e, t) {
          void 0 === l && "content-type" === t.toLowerCase() ? delete p[t] : d.setRequestHeader(t, e);
        }), n.isUndefined(e.withCredentials) || (d.withCredentials = !!e.withCredentials), e.responseType) try {
          d.responseType = e.responseType;
        } catch (t) {
          if ("json" !== e.responseType) throw t;
        }
        "function" == typeof e.onDownloadProgress && d.addEventListener("progress", e.onDownloadProgress), "function" == typeof e.onUploadProgress && d.upload && d.upload.addEventListener("progress", e.onUploadProgress), e.cancelToken && e.cancelToken.promise.then(function (e) {
          d && (d.abort(), f(e), d = null);
        }), void 0 === l && (l = null), d.send(l);
      });
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(22);

    e.exports = function (e, t, r, o, i) {
      var s = new Error(e);
      return n(s, t, r, o, i);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(0);

    e.exports = function (e, t) {
      t = t || {};
      var r = {},
          o = ["url", "method", "params", "data"],
          i = ["headers", "auth", "proxy"],
          s = ["baseURL", "url", "transformRequest", "transformResponse", "paramsSerializer", "timeout", "withCredentials", "adapter", "responseType", "xsrfCookieName", "xsrfHeaderName", "onUploadProgress", "onDownloadProgress", "maxContentLength", "validateStatus", "maxRedirects", "httpAgent", "httpsAgent", "cancelToken", "socketPath"];
      n.forEach(o, function (e) {
        void 0 !== t[e] && (r[e] = t[e]);
      }), n.forEach(i, function (o) {
        n.isObject(t[o]) ? r[o] = n.deepMerge(e[o], t[o]) : void 0 !== t[o] ? r[o] = t[o] : n.isObject(e[o]) ? r[o] = n.deepMerge(e[o]) : void 0 !== e[o] && (r[o] = e[o]);
      }), n.forEach(s, function (n) {
        void 0 !== t[n] ? r[n] = t[n] : void 0 !== e[n] && (r[n] = e[n]);
      });
      var u = o.concat(i).concat(s),
          a = Object.keys(t).filter(function (e) {
        return -1 === u.indexOf(e);
      });
      return n.forEach(a, function (n) {
        void 0 !== t[n] ? r[n] = t[n] : void 0 !== e[n] && (r[n] = e[n]);
      }), r;
    };
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      this.message = e;
    }

    n.prototype.toString = function () {
      return "Cancel" + (this.message ? ": " + this.message : "");
    }, n.prototype.__CANCEL__ = !0, e.exports = n;
  }, function (t, r) {
    t.exports = e;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      for (var r in e) {
        t.hasOwnProperty(r) || (t[r] = e[r]);
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), n(r(1)), n(r(2)), n(r(36));
    var o = r(2);
    t.default = o.default;
  }, function (e, t, r) {
    e.exports = r(14);
  }, function (e, t, r) {
    "use strict";

    var n = r(0),
        o = r(3),
        i = r(15),
        s = r(9);

    function u(e) {
      var t = new i(e),
          r = o(i.prototype.request, t);
      return n.extend(r, i.prototype, t), n.extend(r, t), r;
    }

    var a = u(r(6));
    a.Axios = i, a.create = function (e) {
      return u(s(a.defaults, e));
    }, a.Cancel = r(10), a.CancelToken = r(29), a.isCancel = r(5), a.all = function (e) {
      return Promise.all(e);
    }, a.spread = r(30), e.exports = a, e.exports.default = a;
  }, function (e, t, r) {
    "use strict";

    var n = r(0),
        o = r(4),
        i = r(16),
        s = r(17),
        u = r(9);

    function a(e) {
      this.defaults = e, this.interceptors = {
        request: new i(),
        response: new i()
      };
    }

    a.prototype.request = function (e) {
      "string" == typeof e ? (e = arguments[1] || {}).url = arguments[0] : e = e || {}, (e = u(this.defaults, e)).method ? e.method = e.method.toLowerCase() : this.defaults.method ? e.method = this.defaults.method.toLowerCase() : e.method = "get";
      var t = [s, void 0],
          r = Promise.resolve(e);

      for (this.interceptors.request.forEach(function (e) {
        t.unshift(e.fulfilled, e.rejected);
      }), this.interceptors.response.forEach(function (e) {
        t.push(e.fulfilled, e.rejected);
      }); t.length;) {
        r = r.then(t.shift(), t.shift());
      }

      return r;
    }, a.prototype.getUri = function (e) {
      return e = u(this.defaults, e), o(e.url, e.params, e.paramsSerializer).replace(/^\?/, "");
    }, n.forEach(["delete", "get", "head", "options"], function (e) {
      a.prototype[e] = function (t, r) {
        return this.request(n.merge(r || {}, {
          method: e,
          url: t
        }));
      };
    }), n.forEach(["post", "put", "patch"], function (e) {
      a.prototype[e] = function (t, r, o) {
        return this.request(n.merge(o || {}, {
          method: e,
          url: t,
          data: r
        }));
      };
    }), e.exports = a;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);

    function o() {
      this.handlers = [];
    }

    o.prototype.use = function (e, t) {
      return this.handlers.push({
        fulfilled: e,
        rejected: t
      }), this.handlers.length - 1;
    }, o.prototype.eject = function (e) {
      this.handlers[e] && (this.handlers[e] = null);
    }, o.prototype.forEach = function (e) {
      n.forEach(this.handlers, function (t) {
        null !== t && e(t);
      });
    }, e.exports = o;
  }, function (e, t, r) {
    "use strict";

    var n = r(0),
        o = r(18),
        i = r(5),
        s = r(6);

    function u(e) {
      e.cancelToken && e.cancelToken.throwIfRequested();
    }

    e.exports = function (e) {
      return u(e), e.headers = e.headers || {}, e.data = o(e.data, e.headers, e.transformRequest), e.headers = n.merge(e.headers.common || {}, e.headers[e.method] || {}, e.headers), n.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function (t) {
        delete e.headers[t];
      }), (e.adapter || s.adapter)(e).then(function (t) {
        return u(e), t.data = o(t.data, t.headers, e.transformResponse), t;
      }, function (t) {
        return i(t) || (u(e), t && t.response && (t.response.data = o(t.response.data, t.response.headers, e.transformResponse))), Promise.reject(t);
      });
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(0);

    e.exports = function (e, t, r) {
      return n.forEach(r, function (r) {
        e = r(e, t);
      }), e;
    };
  }, function (e, t) {
    var r,
        n,
        o = e.exports = {};

    function i() {
      throw new Error("setTimeout has not been defined");
    }

    function s() {
      throw new Error("clearTimeout has not been defined");
    }

    function u(e) {
      if (r === setTimeout) return setTimeout(e, 0);
      if ((r === i || !r) && setTimeout) return r = setTimeout, setTimeout(e, 0);

      try {
        return r(e, 0);
      } catch (t) {
        try {
          return r.call(null, e, 0);
        } catch (t) {
          return r.call(this, e, 0);
        }
      }
    }

    !function () {
      try {
        r = "function" == typeof setTimeout ? setTimeout : i;
      } catch (e) {
        r = i;
      }

      try {
        n = "function" == typeof clearTimeout ? clearTimeout : s;
      } catch (e) {
        n = s;
      }
    }();
    var a,
        c = [],
        f = !1,
        l = -1;

    function p() {
      f && a && (f = !1, a.length ? c = a.concat(c) : l = -1, c.length && d());
    }

    function d() {
      if (!f) {
        var e = u(p);
        f = !0;

        for (var t = c.length; t;) {
          for (a = c, c = []; ++l < t;) {
            a && a[l].run();
          }

          l = -1, t = c.length;
        }

        a = null, f = !1, function (e) {
          if (n === clearTimeout) return clearTimeout(e);
          if ((n === s || !n) && clearTimeout) return n = clearTimeout, clearTimeout(e);

          try {
            n(e);
          } catch (t) {
            try {
              return n.call(null, e);
            } catch (t) {
              return n.call(this, e);
            }
          }
        }(e);
      }
    }

    function h(e, t) {
      this.fun = e, this.array = t;
    }

    function m() {}

    o.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
        t[r - 1] = arguments[r];
      }
      c.push(new h(e, t)), 1 !== c.length || f || u(d);
    }, h.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = m, o.addListener = m, o.once = m, o.off = m, o.removeListener = m, o.removeAllListeners = m, o.emit = m, o.prependListener = m, o.prependOnceListener = m, o.listeners = function (e) {
      return [];
    }, o.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, o.cwd = function () {
      return "/";
    }, o.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, o.umask = function () {
      return 0;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(0);

    e.exports = function (e, t) {
      n.forEach(e, function (r, n) {
        n !== t && n.toUpperCase() === t.toUpperCase() && (e[t] = r, delete e[n]);
      });
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(8);

    e.exports = function (e, t, r) {
      var o = r.config.validateStatus;
      !o || o(r.status) ? e(r) : t(n("Request failed with status code " + r.status, r.config, null, r.request, r));
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t, r, n, o) {
      return e.config = t, r && (e.code = r), e.request = n, e.response = o, e.isAxiosError = !0, e.toJSON = function () {
        return {
          message: this.message,
          name: this.name,
          description: this.description,
          number: this.number,
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          config: this.config,
          code: this.code
        };
      }, e;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(24),
        o = r(25);

    e.exports = function (e, t) {
      return e && !n(t) ? o(e, t) : t;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e) {
      return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e);
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t) {
      return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(0),
        o = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];

    e.exports = function (e) {
      var t,
          r,
          i,
          s = {};
      return e ? (n.forEach(e.split("\n"), function (e) {
        if (i = e.indexOf(":"), t = n.trim(e.substr(0, i)).toLowerCase(), r = n.trim(e.substr(i + 1)), t) {
          if (s[t] && o.indexOf(t) >= 0) return;
          s[t] = "set-cookie" === t ? (s[t] ? s[t] : []).concat([r]) : s[t] ? s[t] + ", " + r : r;
        }
      }), s) : s;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    e.exports = n.isStandardBrowserEnv() ? function () {
      var e,
          t = /(msie|trident)/i.test(navigator.userAgent),
          r = document.createElement("a");

      function o(e) {
        var n = e;
        return t && (r.setAttribute("href", n), n = r.href), r.setAttribute("href", n), {
          href: r.href,
          protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
          host: r.host,
          search: r.search ? r.search.replace(/^\?/, "") : "",
          hash: r.hash ? r.hash.replace(/^#/, "") : "",
          hostname: r.hostname,
          port: r.port,
          pathname: "/" === r.pathname.charAt(0) ? r.pathname : "/" + r.pathname
        };
      }

      return e = o(window.location.href), function (t) {
        var r = n.isString(t) ? o(t) : t;
        return r.protocol === e.protocol && r.host === e.host;
      };
    }() : function () {
      return !0;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    e.exports = n.isStandardBrowserEnv() ? {
      write: function write(e, t, r, o, i, s) {
        var u = [];
        u.push(e + "=" + encodeURIComponent(t)), n.isNumber(r) && u.push("expires=" + new Date(r).toGMTString()), n.isString(o) && u.push("path=" + o), n.isString(i) && u.push("domain=" + i), !0 === s && u.push("secure"), document.cookie = u.join("; ");
      },
      read: function read(e) {
        var t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
        return t ? decodeURIComponent(t[3]) : null;
      },
      remove: function remove(e) {
        this.write(e, "", Date.now() - 864e5);
      }
    } : {
      write: function write() {},
      read: function read() {
        return null;
      },
      remove: function remove() {}
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(10);

    function o(e) {
      if ("function" != typeof e) throw new TypeError("executor must be a function.");
      var t;
      this.promise = new Promise(function (e) {
        t = e;
      });
      var r = this;
      e(function (e) {
        r.reason || (r.reason = new n(e), t(r.reason));
      });
    }

    o.prototype.throwIfRequested = function () {
      if (this.reason) throw this.reason;
    }, o.source = function () {
      var e;
      return {
        token: new o(function (t) {
          e = t;
        }),
        cancel: e
      };
    }, e.exports = o;
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e) {
      return function (t) {
        return e.apply(null, t);
      };
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(32),
        o = r(33),
        i = r(34);

    function s(e) {
      if ("string" != typeof e || 1 !== e.length) throw new TypeError("arrayFormatSeparator must be single character string");
    }

    function u(e, t) {
      return t.encode ? t.strict ? n(e) : encodeURIComponent(e) : e;
    }

    function a(e, t) {
      return t.decode ? o(e) : e;
    }

    function c(e) {
      var t = e.indexOf("#");
      return -1 !== t && (e = e.slice(0, t)), e;
    }

    function f(e) {
      var t = (e = c(e)).indexOf("?");
      return -1 === t ? "" : e.slice(t + 1);
    }

    function l(e, t) {
      return t.parseNumbers && !Number.isNaN(Number(e)) && "string" == typeof e && "" !== e.trim() ? e = Number(e) : !t.parseBooleans || null === e || "true" !== e.toLowerCase() && "false" !== e.toLowerCase() || (e = "true" === e.toLowerCase()), e;
    }

    function p(e, t) {
      s((t = Object.assign({
        decode: !0,
        sort: !0,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: !1,
        parseBooleans: !1
      }, t)).arrayFormatSeparator);

      var r = function (e) {
        var t;

        switch (e.arrayFormat) {
          case "index":
            return function (e, r, n) {
              t = /\[(\d*)\]$/.exec(e), e = e.replace(/\[\d*\]$/, ""), t ? (void 0 === n[e] && (n[e] = {}), n[e][t[1]] = r) : n[e] = r;
            };

          case "bracket":
            return function (e, r, n) {
              t = /(\[\])$/.exec(e), e = e.replace(/\[\]$/, ""), t ? void 0 !== n[e] ? n[e] = [].concat(n[e], r) : n[e] = [r] : n[e] = r;
            };

          case "comma":
          case "separator":
            return function (t, r, n) {
              var o = "string" == typeof r && r.split("").indexOf(e.arrayFormatSeparator) > -1 ? r.split(e.arrayFormatSeparator).map(function (t) {
                return a(t, e);
              }) : null === r ? r : a(r, e);
              n[t] = o;
            };

          default:
            return function (e, t, r) {
              void 0 !== r[e] ? r[e] = [].concat(r[e], t) : r[e] = t;
            };
        }
      }(t),
          n = Object.create(null);

      if ("string" != typeof e) return n;
      if (!(e = e.trim().replace(/^[?#&]/, ""))) return n;

      var _iterator = _createForOfIteratorHelper(e.split("&")),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _o = _step.value;

          var _i3 = i(t.decode ? _o.replace(/\+/g, " ") : _o, "="),
              _i4 = _slicedToArray(_i3, 2),
              _e3 = _i4[0],
              _s = _i4[1];

          _s = void 0 === _s ? null : "comma" === t.arrayFormat ? _s : a(_s, t), r(a(_e3, t), _s, n);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      for (var _i = 0, _Object$keys = Object.keys(n); _i < _Object$keys.length; _i++) {
        var _e = _Object$keys[_i];
        var _r2 = n[_e];
        if ("object" == typeof _r2 && null !== _r2) for (var _i2 = 0, _Object$keys2 = Object.keys(_r2); _i2 < _Object$keys2.length; _i2++) {
          var _e2 = _Object$keys2[_i2];
          _r2[_e2] = l(_r2[_e2], t);
        } else n[_e] = l(_r2, t);
      }

      return !1 === t.sort ? n : (!0 === t.sort ? Object.keys(n).sort() : Object.keys(n).sort(t.sort)).reduce(function (e, t) {
        var r = n[t];
        return Boolean(r) && "object" == typeof r && !Array.isArray(r) ? e[t] = function e(t) {
          return Array.isArray(t) ? t.sort() : "object" == typeof t ? e(Object.keys(t)).sort(function (e, t) {
            return Number(e) - Number(t);
          }).map(function (e) {
            return t[e];
          }) : t;
        }(r) : e[t] = r, e;
      }, Object.create(null));
    }

    t.extract = f, t.parse = p, t.stringify = function (e, t) {
      if (!e) return "";
      s((t = Object.assign({
        encode: !0,
        strict: !0,
        arrayFormat: "none",
        arrayFormatSeparator: ","
      }, t)).arrayFormatSeparator);

      var r = function (e) {
        switch (e.arrayFormat) {
          case "index":
            return function (t) {
              return function (r, n) {
                var o = r.length;
                return void 0 === n || e.skipNull && null === n ? r : null === n ? [].concat(_toConsumableArray(r), [[u(t, e), "[", o, "]"].join("")]) : [].concat(_toConsumableArray(r), [[u(t, e), "[", u(o, e), "]=", u(n, e)].join("")]);
              };
            };

          case "bracket":
            return function (t) {
              return function (r, n) {
                return void 0 === n || e.skipNull && null === n ? r : null === n ? [].concat(_toConsumableArray(r), [[u(t, e), "[]"].join("")]) : [].concat(_toConsumableArray(r), [[u(t, e), "[]=", u(n, e)].join("")]);
              };
            };

          case "comma":
          case "separator":
            return function (t) {
              return function (r, n) {
                return null == n || 0 === n.length ? r : 0 === r.length ? [[u(t, e), "=", u(n, e)].join("")] : [[r, u(n, e)].join(e.arrayFormatSeparator)];
              };
            };

          default:
            return function (t) {
              return function (r, n) {
                return void 0 === n || e.skipNull && null === n ? r : null === n ? [].concat(_toConsumableArray(r), [u(t, e)]) : [].concat(_toConsumableArray(r), [[u(t, e), "=", u(n, e)].join("")]);
              };
            };
        }
      }(t),
          n = Object.assign({}, e);

      if (t.skipNull) for (var _i5 = 0, _Object$keys3 = Object.keys(n); _i5 < _Object$keys3.length; _i5++) {
        var _e4 = _Object$keys3[_i5];
        void 0 !== n[_e4] && null !== n[_e4] || delete n[_e4];
      }
      var o = Object.keys(n);
      return !1 !== t.sort && o.sort(t.sort), o.map(function (n) {
        var o = e[n];
        return void 0 === o ? "" : null === o ? u(n, t) : Array.isArray(o) ? o.reduce(r(n), []).join("&") : u(n, t) + "=" + u(o, t);
      }).filter(function (e) {
        return e.length > 0;
      }).join("&");
    }, t.parseUrl = function (e, t) {
      return {
        url: c(e).split("?")[0] || "",
        query: p(f(e), t)
      };
    }, t.stringifyUrl = function (e, r) {
      var n = c(e.url).split("?")[0] || "",
          o = t.extract(e.url),
          i = t.parse(o),
          s = function (e) {
        var t = "";
        var r = e.indexOf("#");
        return -1 !== r && (t = e.slice(r)), t;
      }(e.url),
          u = Object.assign(i, e.query);

      var a = t.stringify(u, r);
      return a && (a = "?".concat(a)), "".concat(n).concat(a).concat(s);
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e) {
      return encodeURIComponent(e).replace(/[!'()*]/g, function (e) {
        return "%".concat(e.charCodeAt(0).toString(16).toUpperCase());
      });
    };
  }, function (e, t, r) {
    "use strict";

    var n = new RegExp("%[a-f0-9]{2}", "gi"),
        o = new RegExp("(%[a-f0-9]{2})+", "gi");

    function i(e, t) {
      try {
        return decodeURIComponent(e.join(""));
      } catch (e) {}

      if (1 === e.length) return e;
      t = t || 1;
      var r = e.slice(0, t),
          n = e.slice(t);
      return Array.prototype.concat.call([], i(r), i(n));
    }

    function s(e) {
      try {
        return decodeURIComponent(e);
      } catch (o) {
        for (var t = e.match(n), r = 1; r < t.length; r++) {
          t = (e = i(t, r).join("")).match(n);
        }

        return e;
      }
    }

    e.exports = function (e) {
      if ("string" != typeof e) throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e + "`");

      try {
        return e = e.replace(/\+/g, " "), decodeURIComponent(e);
      } catch (t) {
        return function (e) {
          for (var t = {
            "%FE%FF": "��",
            "%FF%FE": "��"
          }, r = o.exec(e); r;) {
            try {
              t[r[0]] = decodeURIComponent(r[0]);
            } catch (e) {
              var n = s(r[0]);
              n !== r[0] && (t[r[0]] = n);
            }

            r = o.exec(e);
          }

          t["%C2"] = "�";

          for (var i = Object.keys(t), u = 0; u < i.length; u++) {
            var a = i[u];
            e = e.replace(new RegExp(a, "g"), t[a]);
          }

          return e;
        }(e);
      }
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t) {
      if ("string" != typeof e || "string" != typeof t) throw new TypeError("Expected the arguments to be of type `string`");
      if ("" === t) return [e];
      var r = e.indexOf(t);
      return -1 === r ? [e] : [e.slice(0, r), e.slice(r + t.length)];
    };
  }, function (e, t, r) {
    var n, o, i;
    !function (r, s) {
      "use strict";

      "object" == typeof e.exports ? e.exports = s() : (o = [], void 0 === (i = "function" == typeof (n = s) ? n.apply(t, o) : n) || (e.exports = i));
    }(0, function () {
      "use strict";

      var e = Object.prototype.toString;

      function t(e, t) {
        return null != e && Object.prototype.hasOwnProperty.call(e, t);
      }

      function r(e) {
        if (!e) return !0;
        if (o(e) && 0 === e.length) return !0;

        if ("string" != typeof e) {
          for (var r in e) {
            if (t(e, r)) return !1;
          }

          return !0;
        }

        return !1;
      }

      function n(t) {
        return e.call(t);
      }

      var o = Array.isArray || function (t) {
        return "[object Array]" === e.call(t);
      };

      function i(e) {
        var t = parseInt(e);
        return t.toString() === e ? t : e;
      }

      function s(e) {
        e = e || {};

        var s = function s(e) {
          return Object.keys(s).reduce(function (t, r) {
            return "create" === r ? t : ("function" == typeof s[r] && (t[r] = s[r].bind(s, e)), t);
          }, {});
        };

        function u(r, n) {
          return e.includeInheritedProps || "number" == typeof n && Array.isArray(r) || t(r, n);
        }

        function a(e, t) {
          if (u(e, t)) return e[t];
        }

        function c(e, t, r, n) {
          if ("number" == typeof t && (t = [t]), !t || 0 === t.length) return e;
          if ("string" == typeof t) return c(e, t.split(".").map(i), r, n);
          var o = t[0],
              s = a(e, o);
          return 1 === t.length ? (void 0 !== s && n || (e[o] = r), s) : (void 0 === s && ("number" == typeof t[1] ? e[o] = [] : e[o] = {}), c(e[o], t.slice(1), r, n));
        }

        return s.has = function (r, n) {
          if ("number" == typeof n ? n = [n] : "string" == typeof n && (n = n.split(".")), !n || 0 === n.length) return !!r;

          for (var s = 0; s < n.length; s++) {
            var u = i(n[s]);
            if (!("number" == typeof u && o(r) && u < r.length || (e.includeInheritedProps ? u in Object(r) : t(r, u)))) return !1;
            r = r[u];
          }

          return !0;
        }, s.ensureExists = function (e, t, r) {
          return c(e, t, r, !0);
        }, s.set = function (e, t, r, n) {
          return c(e, t, r, n);
        }, s.insert = function (e, t, r, n) {
          var i = s.get(e, t);
          n = ~~n, o(i) || (i = [], s.set(e, t, i)), i.splice(n, 0, r);
        }, s.empty = function (e, t) {
          var i, a;

          if (!r(t) && null != e && (i = s.get(e, t))) {
            if ("string" == typeof i) return s.set(e, t, "");
            if (function (e) {
              return "boolean" == typeof e || "[object Boolean]" === n(e);
            }(i)) return s.set(e, t, !1);
            if ("number" == typeof i) return s.set(e, t, 0);
            if (o(i)) i.length = 0;else {
              if (!function (e) {
                return "object" == typeof e && "[object Object]" === n(e);
              }(i)) return s.set(e, t, null);

              for (a in i) {
                u(i, a) && delete i[a];
              }
            }
          }
        }, s.push = function (e, t) {
          var r = s.get(e, t);
          o(r) || (r = [], s.set(e, t, r)), r.push.apply(r, Array.prototype.slice.call(arguments, 2));
        }, s.coalesce = function (e, t, r) {
          for (var n, o = 0, i = t.length; o < i; o++) {
            if (void 0 !== (n = s.get(e, t[o]))) return n;
          }

          return r;
        }, s.get = function (e, t, r) {
          if ("number" == typeof t && (t = [t]), !t || 0 === t.length) return e;
          if (null == e) return r;
          if ("string" == typeof t) return s.get(e, t.split("."), r);
          var n = i(t[0]),
              o = a(e, n);
          return void 0 === o ? r : 1 === t.length ? o : s.get(e[n], t.slice(1), r);
        }, s.del = function (e, t) {
          if ("number" == typeof t && (t = [t]), null == e) return e;
          if (r(t)) return e;
          if ("string" == typeof t) return s.del(e, t.split("."));
          var n = i(t[0]);
          return u(e, n) ? 1 !== t.length ? s.del(e[n], t.slice(1)) : (o(e) ? e.splice(n, 1) : delete e[n], e) : e;
        }, s;
      }

      var u = s();
      return u.create = s, u.withInheritedProps = s({
        includeInheritedProps: !0
      }), u;
    });
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      for (var r in e) {
        t.hasOwnProperty(r) || (t[r] = e[r]);
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), n(r(37)), n(r(38));
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(11),
        o = r(1);

    t.useRequest = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        cancelBeforeEveryRequest: !0,
        cancelBeforeUnmount: !0
      };

      var _n$useState = n.useState(!1),
          _n$useState2 = _slicedToArray(_n$useState, 2),
          r = _n$useState2[0],
          i = _n$useState2[1],
          s = n.useRef({
        _cancelers: [],
        cancel: function cancel(e) {
          e && console.log(e), this._cancelers.forEach(function (t) {
            return t(e);
          }), this._cancelers = [];
        }
      });

      return n.useEffect(function () {
        return function () {
          t.cancelBeforeUnmount && s.current.cancel();
        };
      }, []), [function () {
        return t.cancelBeforeEveryRequest && s.current.cancel(), o.AxiosController.cancelerCallbackQueue.push(function (e) {
          s.current._cancelers.push(e);
        }), i(!0), e.apply(void 0, arguments).finally(function () {
          return i(!1);
        });
      }, function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Request Canceled";
        return s.current.cancel(e);
      }, {
        loading: r
      }];
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(11);

    t.useUnmountGuard = function () {
      var e = n.useRef(!1);
      n.useEffect(function () {
        return function () {
          e.current = !0;
        };
      }, []);
      return {
        useState: function useState(t) {
          var _n$useState3 = n.useState(t),
              _n$useState4 = _slicedToArray(_n$useState3, 2),
              r = _n$useState4[0],
              o = _n$useState4[1];

          return [r, function (t) {
            e.current ? console.log("Prevent a state update of unmounted component;") : o(t);
          }];
        },
        useReducer: function useReducer(t, r) {
          var _n$useReducer = n.useReducer(t, r),
              _n$useReducer2 = _slicedToArray(_n$useReducer, 2),
              o = _n$useReducer2[0],
              i = _n$useReducer2[1];

          return [o, function (t) {
            e.current ? console.log("Prevent a action dispatch of unmounted component;") : i(t);
          }];
        }
      };
    };
  }]);
});